export class TemplateDashboardAgencyCustomerComponent implements ng.IComponentOptions {
    public templateUrl = require('./dashboard-agency-customer.html?external');
}
